import styled from 'styled-components';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import query from '../../../const/mediaQueries';
import Checkbox from '../../atoms/Checkbox';
import { colors } from '../../../defaultTheme';
import Textfield from '../../atoms/Textfield';
import { FA_EXCLAMATION_CIRCLE } from '../../../const/iconProps';
export const Container = styled.div `
  width: 100%;
`;
export const StyledInput = styled(Textfield) `
  margin: 24px 0 0;
  width: 100%;
`;
export const FirstInput = styled(Textfield) `
  width: 100%;
  margin: 16px 0 0;
`;
export const LastInput = styled(Textfield) `
  width: 100%;
  margin: 24px 0
    ${({ hasMakeDefaultOption }) => (hasMakeDefaultOption ? '0' : '32px')};
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;
export const InputWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;
export const ImageContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const ImageWrapper = styled.div `
  display: block;
  width: 100%;
  max-width: 440px;
  margin-bottom: 32px;

  @media ${query.greaterThanMedium} {
    margin-bottom: 0;
    margin-left: 16px;
  }
`;
export const Image = styled.img `
  max-width: 100%;
  max-height: 100%;
`;
export const StyledCheckbox = styled(Checkbox) `
  justify-content: flex-start;
  margin-bottom: 32px;
`;
export const ErrorIcon = () => {
    return (React.createElement(FontAwesomeIcon, { icon: FA_EXCLAMATION_CIRCLE, color: colors.error, size: "xs" }));
};
